import React, { useState, useEffect, useRef } from "react";
import { ModalWithIcon } from "../../RfModal/ModalWithIcon";
import { CancellationOfferDefinition } from "@functions/plans/info/cancellationOffers";
import { openOnboardingCalendly } from "../../../../../clientServices/openOnboardingCalendly";
import { DowngradePlanTargets } from "../../../../../state/types";

type CancelPlanExternalLinkModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
    offer: CancellationOfferDefinition;
    workspaceId: string;
    currentPlan: string;
    selectedDowngradePlan: DowngradePlanTargets;
    isDowngrade: boolean;
};

export function CancelPlanExternalLinkModal({
    isOpen,
    onClose,
    onCancel,
    offer,
    workspaceId,
    currentPlan,
    selectedDowngradePlan,
    isDowngrade
}: CancelPlanExternalLinkModalProps) {
    const [loadingAction, setLoadingAction] = useState<"accept" | "cancel" | null>(null);

    const lastIsOpenRef = useRef(isOpen);
    useEffect(() => {
        if (isOpen === lastIsOpenRef.current) return;
        lastIsOpenRef.current = isOpen;

        eventTracker.event({
            type: `Churn Onboarding Call Offer Modal ${isOpen ? "Opened" : "Closed"}`,
            data: { workspaceId, currentPlan, selectedDowngradePlan, isDowngrade }
        });
    }, [isOpen]);

    const handleAccept = () => {
        eventTracker.event({
            type: "Churn Onboarding Call Offer Modal Accepted",
            data: { workspaceId, currentPlan, selectedDowngradePlan, isDowngrade }
        });

        setLoadingAction("accept");
        if (offer.variantConfig.openAction === "openOnboardingCalendly") {
            openOnboardingCalendly("cancellation_offer");
        }
        eventTracker.event({ type: "Cancellation Offer Accepted", data: { offer_id: offer.id } });
        onClose();
    };

    const handleCancel = async () => {
        eventTracker.event({
            type: "Churn Onboarding Call Offer Modal Rejected",
            data: { workspaceId, currentPlan, selectedDowngradePlan, isDowngrade }
        });

        setLoadingAction("cancel");
        await onCancel();
    };

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            title={offer.heading}
            icon={offer.icon}
            cancelButtonText="No Thanks, Cancel Now"
            submitButtonText={offer.ctaText}
            type="info"
            onCancel={handleCancel}
            onSubmit={handleAccept}
            submitButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "accept" }}
            cancelButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "cancel" }}
            closeOnCancel={false}
        >
            <p className="text-sm text-gray-700">{offer.description}</p>
        </ModalWithIcon>
    );
}
